module.exports = __webpack_public_path__ + "img/Legends-Hoodie-01@2x.87712fc9.jpg";